import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PowertrainWizardComponent from './PowertrainWizardComponent';
import { getModel } from './selectors';
import * as actions from './actions';
import './style.scss';


const PowertrainWizardContainer = (props) => {

    useEffect(() => {
        return () => {
            props.actions.clearStore();
        };
    }, []);

    return <PowertrainWizardComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return { model };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const PowertrainWizardContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(PowertrainWizardContainer);

export default PowertrainWizardContainerConn;
